export class WebmsgModel {
  id: number;
    user_id: string;
  message: string;
  message_title: string;
  message_type: string;
  is_read: boolean;
  msg_show_type: number;
}
